export default class AgeList {
    static ageArray = [
        {
            displayName: "Under 1 year",
            value: 0
        },
        {
            displayName: "1 year",
            value: 1
        },
        {
            displayName: "2 years",
            value: 2
        },
        {
            displayName: "3 years",
            value: 3
        },
        {
            displayName: "4 years",
            value: 4
        },
        {
            displayName: "5 years",
            value: 5
        },
        {
            displayName: "6 years",
            value: 6
        },
        {
            displayName: "7 years",
            value: 7
        },
        {
            displayName: "8 years",
            value: 8
        },
        {
            displayName: "9 years",
            value: 9
        },
        {
            displayName: "10 years",
            value: 10
        },
        {
            displayName: "11 years",
            value: 11
        },
        {
            displayName: "12 years",
            value: 12
        },
        {
            displayName: "13 years",
            value: 13
        }
    ];

    static getAgeList = (placeholder) => {
        let list = [...AgeList.ageArray];
        if (placeholder) {
            list.unshift({
                displayName: placeholder,
                style: "color: '#999999'",
                value: null
            })
        }
        return list;
    }
}